export class Square {
  constructor(index, position, type) {
    this.index = index;
    this.position = position;
    this.type = type;
  }
}

export class MovementSquare extends Square {
  constructor(index, position, type, squareIndex) {
    super(index, position, type);
    this.squareIndex = squareIndex;
  }
}
